<template>
  <nav class="mobile-footer">
    <ul class="footer-menu">
      <li
        v-for="menu in menuList"
        :key="menu.id"
        :class="{ active: active === menu.id }"
      >
        <router-link :to="menu.path">
          <span :class="`iconfont ${menu.icon}`" style="font-size: 16px"></span>
          <span>{{ menu.name }}</span>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
// 可根据需要添加逻辑
export default {
  name: "MobileFooter",
  data() {
    return {};
  },
  computed: {
    active() {
      if (this.$route.path === "/h5/Home") {
        return 0;
      } else if (this.$route.path === "/h5/systems") {
        return 1;
      } else if (this.$route.path === "/h5/messages") {
        return 2;
      } else if (this.$route.path === "/h5/mine") {
        return 3;
      }
    },
    menuList() {
      return [
        {
          name: this.$t("menubar.home"),
          icon: "icon-Home",
          path: "/h5/Home",
          id: 0,
        },
        {
          name: this.$t("menubar.apps"),
          icon: "icon-app",
          path: "/h5/systems",
          id: 1,
        },
        {
          name: this.$t("menubar.message"),
          icon: "icon-xiaoxi",
          path: "/h5/messages",
          id: 2,
        },
        {
          name: this.$t("menubar.mine"),
          icon: "icon-mine",
          path: "/h5/mine",
          id: 3,
        },
      ];
    },
  },
};
</script>

<style scoped>
.mobile-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  border-top: 1px solid #eee;
  z-index: 100;
  height: 56px;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.03);
}

.footer-menu {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}

.footer-menu li {
  color: #999999;
}

.active {
  color: #6293ff !important;
}

.footer-menu li a {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: inherit;
  text-decoration: none;
  font-size: 12px;
}

.iconfont {
  font-size: 24px;
  margin-bottom: 4px;
  color: inherit;
}
</style>
